import { IS_LOADING, LIST } from './PartnersActions';

const INITIAL_STATE = {
  isLoading: true,
  results: undefined,
  page: 0,
  total: 0,
};

const PartnersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case IS_LOADING: {
      return { ...state, isLoading: action.payload || true };
    }
    case LIST:
      return {
        ...state,
        isLoading: false,
        results: action.payload.results,
        page: action.payload.page,
        total: action.payload.total,
      };
    default:
      return { ...state };
  }
};

export default PartnersReducer;
